import { BaseEntity } from './base-entity';
import { GeoJSON } from 'leaflet';
import { DataEntry } from './indicator-data';
import { Scale } from './scale';
import { SafeHtml } from '@angular/platform-browser';
import { DataLayerTypeIcon } from '../stores/data-layer-type/data-layer-type.selectors';

export interface GeoData extends BaseEntity {
  geoSource?: string;
  geoJson?: string;
  poiJson: boolean;
}

export interface FeatureCollection extends GeoJSON.FeatureCollection {
  grouped?: boolean;
}

export interface Feature {
  type: string;
  properties: FeatureProperties;
  data?: any;
  geometry: {
    coordinates: number[];
    type: 'Polygon' | 'Point';
  };
}

export interface Projection {
  value: string;
  label: string;
}

export interface FeatureProperties {
  key: string;
  name: string;
  group?: string;
  isPoi?: boolean;
  [key: string]: any;
}

export interface KeyValueDistricts {
  [key: string]: FeatureProperties;
}
export interface ComparisonValue extends BaseEntity {
  key: string;
  name: string;
  fixed?: boolean;
}

export interface PoiMarkerOptions {
  latlng: L.LatLngExpression;
  data: DataEntry | undefined;
  scales: Scale[] | undefined;
  colors: string[];
  icon: DataLayerTypeIcon | null;
  size?: number;
}
export const supportedProjections: Projection[] = [
  { value: 'EPSG:4326', label: 'WGS 84' },
  { value: 'EPSG:8089', label: 'WGS 84 / Zone 32' },
  { value: 'EPSG:32632', label: 'WGS 84 / UTM Zone 32N' },
  { value: 'EPSG:3857', label: 'WGS 84 / Spherical Mercator' },
  { value: 'EPSG:32624', label: 'WGS 84 / UTM Zone 24N' },
  { value: 'EPSG:25832', label: 'ETRS89 / UTM Zone 32N' },
  { value: 'EPSG:3044', label: 'ETRS89 / UTM Zone 32N (N-E)' },
  { value: 'EPSG:4647', label: 'ETRS89 / UTM Zone 32N (zE-N)' },
  { value: 'EPSG:25833', label: 'ETRS89 / UTM Zone 33N (Europe)' },
  { value: 'EPSG:31463', label: 'DHDN / 3-degree Gauss zone 3' },
  { value: 'EPSG:31466', label: 'DHDN / 3-degree Gauss-Kruger zone 2' },
  { value: 'EPSG:31467', label: 'DHDN / 3-degree Gauss-Kruger zone 3' },
  { value: 'EPSG:31468', label: 'DHDN / 3-degree Gauss-Kruger zone 4' },
  { value: 'EPSG:31469', label: 'DHDN / 3-degree Gauss-Kruger zone 5' },
  {
    value: 'EPSG:2397',
    label: 'Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3',
  },
  {
    value: 'EPSG:2398',
    label: 'Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4',
  },
  {
    value: 'EPSG:2399',
    label: 'Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5',
  },
];
